import { render, staticRenderFns } from "./BookingsNew.vue?vue&type=template&id=75406a76"
import script from "./BookingsNew.vue?vue&type=script&lang=js"
export * from "./BookingsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports